(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindCpsDeliveryFilter(root) {
      if (!root || root.dataset.cpsDeliveryFilterBound) return;
      var wrap = root.querySelector('[data-cps-delivery-toggle]');
      if (!wrap) return;
      root.dataset.cpsDeliveryFilterBound = 'true';
      wrap.querySelectorAll('[data-cps-delivery-filter]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.classList.contains('active') ? 'true' : 'false');
      });
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cps-delivery-filter]');
        if (!btn || !wrap.contains(btn)) return;
        var filter = btn.getAttribute('data-cps-delivery-filter') || 'all';
        wrap.querySelectorAll('[data-cps-delivery-filter]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-cps-grid-cards] .category-product-showcase__slide--grid').forEach(function (card) {
          var d = card.getAttribute('data-delivery') || '';
          if (filter === 'all') {
            card.style.removeProperty('display');
          } else {
            card.style.display = d === filter ? '' : 'none';
          }
        });
      });
    }

    function init(root) {
      if (!root || root.dataset.cpsInitialized) return;
      if (root.dataset.cpsProductMode === 'grid') {
        root.dataset.cpsInitialized = 'true';
        bindCpsDeliveryFilter(root);
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('skipp:user-location-changed'));
        }, 0);
        return;
      }
      root.dataset.cpsInitialized = 'true';
      var tabs = root.querySelectorAll('.category-product-showcase__tab[data-cps-tab]');
      var panels = root.querySelectorAll('[data-cps-panel]');
      var seeAll = root.querySelector('[data-cps-see-all]');

      function activate(targetId) {
        tabs.forEach(function (tab) {
          var selected = tab.getAttribute('data-cps-tab') === targetId;
          tab.classList.toggle('active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach(function (panel) {
          var show = panel.getAttribute('data-cps-panel') === targetId;
          panel.hidden = !show;
          panel.classList.toggle('category-product-showcase__panel--active', show);
          if (!show) {
            panel.removeAttribute('data-cps-active-brands');
            panel.querySelectorAll('.category-product-showcase__slide[data-vendor]').forEach(function (slide) {
              slide.style.removeProperty('display');
            });
            panel.querySelectorAll('[data-cps-brand-filter]').forEach(function (btn) {
              btn.classList.remove('skipp-plp-brand-filter__chip--active');
              btn.setAttribute('aria-pressed', 'false');
            });
          }
          if (show) {
            var track = panel.querySelector('[data-cps-carousel] .category-product-showcase__carousel-track');
            if (track) track.scrollLeft = 0;
            var activeTab = root.querySelector(
              '.category-product-showcase__tab[data-cps-tab="' + targetId + '"]'
            );
            var url = activeTab ? activeTab.getAttribute('data-collection-url') || '' : '';
            var logoUrl = activeTab ? activeTab.getAttribute('data-collection-logo-url') || '' : '';
            var collName = activeTab ? activeTab.getAttribute('data-collection-name') || '' : '';
            var fallLetter = activeTab ? activeTab.getAttribute('data-collection-fallback-letter') || '?' : '?';
            var labelBase = seeAll ? seeAll.getAttribute('data-cps-see-all-label') || '' : '';
            if (seeAll) {
              seeAll.hidden = !url;
              if (seeAll.hasAttribute('aria-hidden')) seeAll.removeAttribute('aria-hidden');
              if (!url) {
                seeAll.setAttribute('aria-hidden', 'true');
              }
              seeAll.href = url || '#';
              var aria = labelBase;
              if (collName) aria = aria + ' — ' + collName;
              seeAll.setAttribute('aria-label', aria);
              var img = seeAll.querySelector('[data-cps-see-all-logo]');
              var fallback = seeAll.querySelector('[data-cps-see-all-fallback]');
              var frame = seeAll.querySelector('.category-product-showcase__see-all-frame');
              if (logoUrl && img) {
                img.src = logoUrl;
                img.alt = collName ? collName + ' logo' : '';
                img.removeAttribute('hidden');
                if (fallback) fallback.setAttribute('hidden', '');
                if (frame) frame.classList.remove('category-product-showcase__see-all-frame--empty');
              } else if (img) {
                img.removeAttribute('src');
                img.alt = '';
                img.setAttribute('hidden', '');
                if (fallback) {
                  fallback.removeAttribute('hidden');
                  fallback.textContent = fallLetter;
                }
                if (frame) frame.classList.add('category-product-showcase__see-all-frame--empty');
              }
            }
          }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-cps-tab'));
        });
        tab.addEventListener('keydown', function (e) {
          var keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
          if (keys.indexOf(e.key) === -1) return;
          e.preventDefault();
          var tabIds = [];
          tabs.forEach(function (t) {
            tabIds.push(t.getAttribute('data-cps-tab'));
          });
          var idx = tabIds.indexOf(tab.getAttribute('data-cps-tab'));
          var next = idx;
          if (e.key === 'ArrowRight') next = (idx + 1) % tabIds.length;
          if (e.key === 'ArrowLeft') next = (idx - 1 + tabIds.length) % tabIds.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabIds.length - 1;
          var nextTab = root.querySelector(
            '.category-product-showcase__tab[data-cps-tab="' + tabIds[next] + '"]'
          );
          if (nextTab) {
            nextTab.focus();
            activate(tabIds[next]);
          }
        });
      });

      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('skipp:user-location-changed'));
      }, 0);
    }

    document.querySelectorAll('[data-category-product-showcase]').forEach(init);

    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('[data-category-product-showcase]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.collectionImmersiveHeader = this.querySelector('.app-page-header--collection, .app-page-header--overlay');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      if (!this.header) return;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.collectionImmersiveHeader && window.matchMedia('(max-width: 768px)').matches) {
        this.header.classList.add('shopify-section-header-sticky');
        this.preventHide = true;
        return;
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.collectionImmersiveHeader && window.matchMedia('(max-width: 768px)').matches) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (disclosure && typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || (this.header && this.header.querySelector('details-modal'));
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-fashion-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIfs(section) {
      if (!section || section.dataset.ifsBound === 'true') return;
      section.dataset.ifsBound = 'true';

      var viewport = section.querySelector('[data-ifs-viewport]');
      var track = section.querySelector('[data-ifs-track]');
      if (!viewport || !track) return;

      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-ifs-slide]'));
      if (!slides.length) return;

      var enableCarousel = section.getAttribute('data-enable-carousel') === 'true';
      var enableSwipe = section.getAttribute('data-enable-swipe') === 'true';
      var enableAutoscroll = section.getAttribute('data-enable-autoscroll') === 'true';
      var infinite = section.getAttribute('data-infinite-loop') === 'true';
      var pauseInteraction = section.getAttribute('data-pause-interaction') === 'true';
      var pauseHover = section.getAttribute('data-pause-on-hover') === 'true';
      var animStyle = section.getAttribute('data-anim-style') || 'fade';
      var intervalSec = parseInt(section.getAttribute('data-autoplay-interval'), 10) || 5;
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-ifs-dot]'));
      var prevBtn = section.querySelector('[data-ifs-prev]');
      var nextBtn = section.querySelector('[data-ifs-next]');
      var mobileMq = window.matchMedia('(max-width: 749px)');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var index = 0;
      var timer = null;
      var paused = false;
      var interacting = false;
      var touchStartX = 0;
      var touchDeltaX = 0;

      function isMobile() {
        return mobileMq.matches;
      }

      function shouldCarousel() {
        if (isMobile()) return true;
        return enableCarousel;
      }

      function setActive(i, animate) {
        if (!slides.length) return;

        if (!shouldCarousel()) {
          slides.forEach(function (slide) {
            slide.classList.add('is-active');
          });
          track.style.transform = 'none';
          return;
        }

        if (infinite) {
          if (i >= slides.length) i = 0;
          if (i < 0) i = slides.length - 1;
        } else {
          i = Math.max(0, Math.min(i, slides.length - 1));
        }
        index = i;

        if (animStyle === 'fade' || (!shouldCarousel() && animStyle !== 'slide')) {
          slides.forEach(function (slide, si) {
            slide.classList.toggle('is-active', si === index);
          });
          track.style.transform = 'translateX(0)';
        } else {
          if (!animate) track.style.transition = 'none';
          track.style.transform = 'translateX(-' + index * 100 + '%)';
          slides.forEach(function (slide, si) {
            slide.classList.toggle('is-active', si === index);
          });
          if (!animate) {
            track.offsetHeight;
            track.style.transition = '';
          }
        }

        dots.forEach(function (dot, di) {
          var on = di === index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function next() {
        setActive(index + 1, true);
      }

      function prev() {
        setActive(index - 1, true);
      }

      function startAutoplay() {
        stopAutoplay();
        if (!enableAutoscroll || reduced || slides.length <= 1 || !shouldCarousel()) return;
        timer = window.setInterval(function () {
          if (paused || interacting) return;
          next();
        }, intervalSec * 1000);
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { if (!shouldCarousel()) return; prev(); startAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { if (!shouldCarousel()) return; next(); startAutoplay(); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-ifs-dot'), 10);
          if (!isNaN(i)) {
            setActive(i, true);
            startAutoplay();
          }
        });
      });

      if (enableSwipe || isMobile()) {
        viewport.addEventListener(
          'touchstart',
          function (e) {
            if (!shouldCarousel()) return;
            touchStartX = e.changedTouches[0].screenX;
            touchDeltaX = 0;
            if (pauseInteraction) interacting = true;
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchmove',
          function (e) {
            if (!shouldCarousel()) return;
            touchDeltaX = e.changedTouches[0].screenX - touchStartX;
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchend',
          function () {
            if (!shouldCarousel()) return;
            if (Math.abs(touchDeltaX) > 40) {
              if (touchDeltaX < 0) next();
              else prev();
              startAutoplay();
            }
            if (pauseInteraction) {
              window.setTimeout(function () {
                interacting = false;
              }, 400);
            }
          },
          { passive: true }
        );
      }

      if (pauseHover) {
        section.addEventListener('mouseenter', function () {
          paused = true;
        });
        section.addEventListener('mouseleave', function () {
          paused = false;
        });
      }

      if (pauseInteraction) {
        viewport.addEventListener('pointerdown', function () {
          interacting = true;
        });
        viewport.addEventListener('pointerup', function () {
          window.setTimeout(function () {
            interacting = false;
          }, 600);
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) startAutoplay();
              else stopAutoplay();
            });
          },
          { threshold: 0.25 }
        ).observe(section);
      } else {
        startAutoplay();
      }

      mobileMq.addEventListener('change', function () {
        setActive(index, false);
      });

      setActive(0, false);
    }

    document.querySelectorAll('.ifs[data-section-id]').forEach(initIfs);

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.ifs[data-section-id]');
      if (section) initIfs(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
